module.exports = __webpack_public_path__ + "static/img/xpcw-member-header.416ec6a3.png";